<template>
  <div id="Content">
     <div class="publishPreviewNav">
      <img src="../../../../img/previewLogo.png" alt="" />
      <span class="publishNavTitle">大百科</span>
    </div>
    <!-- 页面标题 -->
    <div class="contentBox" id="mediaContent">
      <div class="articleTitle">
        <p>{{ articleTitle }}</p>
      </div>
      <div class="basicInfo">
        <!-- <div class="moduleTitle">基本信息</div> -->
        <!-- <div class="basicContent">
          <div class="authorText" v-if="basicInfo.subjectInfo">
            <p><span>分支：</span>{{ basicInfo.subjectInfo }}</p>
          </div>
          <div class="authorText" v-if="basicInfo.securityLevel">
            <p v-if="basicInfo.securityLevel == 10">
              <span>安全级别：</span>低
            </p>
            <p v-if="basicInfo.securityLevel == 20">
              <span>安全级别：</span>中
            </p>
            <p v-if="basicInfo.securityLevel == 30">
              <span>安全级别：</span>高
            </p>
            <p v-if="basicInfo.securityLevel == 40">
              <span>安全级别：</span>最高
            </p>
          </div>
        </div> -->
      </div>
      <!-- <div class="headText" v-if="headTextList != []">
        <div class="moduleTitle">条头</div>
        <div class="infoText">
          <p v-for="item in headTextList" :key="item">
            <span>{{ item.name }}:</span>
            {{ item.value }}
          </p>
        </div>
      </div> -->
      <!-- <div class="summaryFields" v-if="summaryFieldsList != []">
        <div class="moduleTitle">摘要</div>
        <div class="infoText">
          <p v-for="item in summaryFieldsList" :key="item">
            <span>{{ item.name }}:</span>
            {{ item.value }}
          </p>
        </div>
      </div> -->
      <div class="description" v-if="description != ''">
        <div class="moduleTitle">描述</div>
        <div class="descTextContent"></div>
      </div>
      <div class="mainContent">
        <div class="moduleTitle">多媒体内容</div>
        <div class="previewContent">
          <div class="imgPreviewBox" v-if="currentType == 1">
            <div v-for="item in mediaSetList" :key="item.id">
              <img class="previewImg" :src="item.url" />
              <p>{{ item.title }}</p>
            </div>
          </div>
          <div class="imgPreviewBox" v-if="currentType == 2">
            <div v-for="item in mediaSetList" :key="item.id">
              <video class="previewVideo" controls>
                <source :src="item.url" type="video/mp4" />
              </video>
              <p>{{ item.title }}</p>
            </div>
          </div>
          <div class="imgPreviewBox" v-if="currentType == 3">
            <div v-for="item in mediaSetList" :key="item.id">
              <audio controls style="width: 50%">
                <source :src="item.url" type="audio/mp3" />
              </audio>
              <p>{{ item.title }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import cookies from "vue-cookies";
export default {
  data() {
    return {
      articleTitle: "",
      currentType: 1,
      description: "",
      mediaSetList: [],
    };
  },
  props: {
    topIndex: String,
  },
  mounted() {
    let that = this;
    // 统一验证token
    var currentToken = cookies.get("token");
    $.ajaxSetup({
      headers: {
        AuthorizationToken: currentToken,
      },
      complete: function (xhr) {
        if (xhr.responseJSON.code == 401) {
          window.location.href = "/";
        }
      },
    });
    $.ajax({
      type: "GET",
      dataType: "json",
      url: "/zyk/resource/previewSet",
      data: { id: this.$route.query.id },
      contentType: "application/json;charset=utf-8",
      success: function (response) {
        if (response.code == 200) {
          var data = response.obj;
          that.currentType = data.type;

          //   页面标题
          that.articleTitle = data.title;
          //   页面摘要
          if (data.description != null) {
            that.description = data.description;
            setTimeout(function () {
              $(".descTextContent").html(data.description);
            }, 2000);
          }

          var metaIdArry = data.metaIds.split("##"),
            metaUrlArry = data.metaUrls.split("##"),
            metaPosterArry = data.metaPosters.split("##"),
            metaTitleArry = data.metaTitles.split("##");

          for (var i = 0; i < metaIdArry.length; i++) {
            that.mediaSetList[i] = {
              id: metaIdArry[i],
              url: metaUrlArry[i],
              poster: metaPosterArry[i],
              title: metaTitleArry[i],
            };
          }
          console.log(that.mediaSetList);
          //   that.sourceInfo = data.sourceInfo.name;
          if (data.subjectInfo != null) {
            that.basicInfo.subjectInfo = data.subjectInfo.name;
          }
          if (data.securityLevel) {
            that.basicInfo.securityLevel = data.securityLevel;
          }
          setTimeout(function () {
            var pWidth = $(".imgPreviewBox img").width();
            $(".imgPreviewBox p").width(pWidth);
          }, 1000);
        } else {
          that.$message({
            message: response.msg,
            duration: 0,
            showClose: true,
            type: "error",
            offset: 100,
          });
        }
      },
      error: function (data) {
        console.log(data);
      },
    });
  },
  methods: {
    getChild() {
      console.log(this.index);
    },
    changePlayStatus(status) {
      //获取子组件的播放状态
      if (status) {
        this.disabledShot = false;
      } else {
        this.disabledShot = true;
        this.sourceUrl = "";
        this.checkedPontsName = "";
      }
    },
  },
};
</script>

<style>
#mediaContent .previewContent {
  text-align: center;
}

#mediaContent .previewVideo {
  width: 100%;
}

.pageTitle {
  line-height: 100px;
  color: #fff;
  font-size: 24px;
  padding-left: 100px !important;
  background: #666;
  height: auto !important;
}

/* #Content .contentBox {
  padding: 0 20%;
} */

#Content .contentBox .articleTitle p {
  font-size: 40px;
  padding: 20px 0;
  color: #000;
  font-weight: bolder;
}

#Content .contentBox .previewContent p {
  /* line-height: 2.5em; */
  font-size: 16px;
}
/* #Content .contentBox .previewContent {
  padding: 20px 0;
} */

#Content .contentBox .moduleTitle {
  font-size: 22x;
  font-weight: bolder;
  border-bottom: 1px solid rgba(35, 77, 60, 0.4);
  color: #295a46;
  padding-bottom: 10px;
  margin-bottom: 20px;
  margin-top: 30px;
}

#Content .contentBox .mainContent {
  margin-top: 20px;
  margin-bottom: 50px;
}

#Content .contentBox .basicInfo .basicContent {
  overflow: auto;
}

#Content .contentBox .basicInfo .basicContent::after {
  content: "";
  display: inline-block;
  clear: both;
}

#Content .contentBox .basicInfo .basicContent div {
  float: left;
  width: 50%;
  margin-bottom: 20px;
}

#Content .contentBox .basicInfo .basicContent p span {
  font-weight: bolder;
}

.infoText {
  overflow: auto;
}

.infoText::after {
  content: "";
  display: inline-block;
  clear: both;
}

.infoText p {
  float: left;
  width: 50%;
  margin-bottom: 20px;
}

.infoText p span {
  font-weight: bolder;
}

.imgPreviewBox img {
  max-width: 100%;
}

.imgPreviewBox p {
  border: 1px solid #dcdfe6;
  border-bottom: 2px solid #50b58d;
  margin: 0 auto;
  margin-top: -5px;
  margin-bottom: 20px;
  max-width: 100%;
}

.wzgContent,
.zjrjjContent {
  text-indent: 2em;
  line-height: 2.1em;
}
</style>
